export const admin = {
  common: {
    loading: 'Loading…',
    loadingOrganiser: 'Loading organiser…',
    couldNotLoadEvents: 'Could not load courses',
    noEventsAvailable: 'No courses available',
    getTickets: 'Get Tickets',
    soldOut: 'Sold Out',
    free: 'Free',
    view: 'View',
    online: 'Online',
    ticketsLeft: '{remaining} left',
    saveEvent: 'Save course',
    removeFromSaved: 'Remove from saved',
    datesCount: '{count} dates',
  },
  app: {},
  organiser: {
    loadErrorTitle: 'Could not load organiser information',
    eventsByOrganiser: 'Courses by {organiserName}',
    noEventsBody: 'Check back soon for upcoming courses.',
  },
  instancePicker: {
    title: 'Choose your course',
    subtitle: 'Select an organiser to browse and buy tickets.',
    browseAllTitle: 'Browse all courses',
    browseAllDescription: 'View courses from all organisers in one place',
    browseEvents: 'Browse courses',
  },
  directory: {
    loadingEvents: 'Loading courses...',
    searchPlaceholder: 'Search courses, organisers, locations…',
    title: 'Course Directory',
    seoTitle: 'Course Directory — Browse all courses',
    seoDescription: 'Discover courses from organisers across the platform. Browse, filter, and get tickets.',
    jsonldListName: 'Course Directory',
    jsonldListDescription: 'Courses from multiple organisers',
    eventsCountFromAllOne: '1 course from all organisers',
    eventsCountFromAllOther: '{count} courses from all organisers',
    browseEventsFromAll: 'Browse courses from all organisers',
    sortUpcoming: 'Upcoming first',
    sortPriceLowHigh: 'Price: low to high',
    sortNameAZ: 'Name A–Z',
    inPerson: 'In person',
    saved: 'Saved',
    locationPlaceholder: 'Location',
    allLocations: 'All locations',
    clearFilters: 'Clear filters ({count})',
    categoryAll: 'All',
    noSavedEvents: 'No saved courses',
    noSavedEventsBody: 'Save courses by clicking the ♡ on any course card.',
    noEventsFound: 'No courses found',
    noEventsFoundFilteredBody: 'Try a different search or clear some filters.',
    noEventsFoundBody: 'No courses are currently listed in the directory.',
    loadMoreEvents: 'Load more courses',
    showingCount: 'Showing {shown} of {total}',
    organiserNotFound: 'Organiser not found',
    backToDirectory: 'Back to directory',
    upcomingEvents: 'Upcoming courses',
    eventsListedCountOne: '1 course listed',
    eventsListedCountOther: '{count} courses listed',
    noEventsListed: 'No courses listed',
    noEventsListedBody: "This organiser hasn't listed any courses in the directory yet.",
    allEventsButton: 'All courses',
    organiserSeoTitle: '{organiserName} — Courses',
    organiserSeoDescriptionFallback: 'Browse upcoming courses from {organiserName}.',
  },
  ticketingEnabledGuard: {
    title: 'Ticketing unavailable',
    description: 'This organiser does not currently offer ticket sales.',
  },
};
